import React, { useState } from 'react'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaForm } from './components'

const PdcaNew = () => {
  const [loading, setLoading] = useState(false)

  return (
    <Page title="Novo PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading} />
        <ContentHeader title="Novo PDCA" />
        <PdcaForm setLoading={setLoading} mode="new" />
      </Container>
    </Page>
  )
}

export default PdcaNew
